import { render } from "./ListScroll.vue?vue&type=template&id=3555c176&scoped=true&bindings={\"probeType\":\"props\",\"click\":\"props\",\"scrollX\":\"props\",\"listenScroll\":\"props\",\"scrollData\":\"props\",\"pullup\":\"props\",\"pulldown\":\"props\",\"beforeScroll\":\"props\",\"refreshDelay\":\"props\",\"initScroll\":\"options\"}"
import script from "./ListScroll.vue?vue&type=script&lang=js"
export * from "./ListScroll.vue?vue&type=script&lang=js"

import "./ListScroll.vue?vue&type=style&index=0&id=3555c176&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-3555c176"

export default script